/* eslint no-param-reassign: "off" */
import * as types from './mutation-types';

export default {
  [types.SHOW_SOCIAL_POST_DIALOG]: state => {
    state.socialPostModal = true;
  },

  [types.HIDE_SOCIAL_POST_DIALOG]: state => {
    state.socialPostModal = false;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/modals/mutations.js